module.exports = __webpack_public_path__ + "img/auction.b34f59c3.png";